import React, { useState, useEffect, Fragment } from "react";
import axios from "axios";
import { uri } from "../../../../help/Api";

import LoadingPage from "../../../../services/LoadingPage";

import * as _ from "lodash";
import { stElemnt } from "../../../../St/Reviews/cStyle";
import { ButtonBase, Grid, Typography } from "@material-ui/core";
import { useInvAF } from "../../../../St/Reviews/UseStyle";
import { sto } from "../../../../Context/InshData";
import FooterSand from "./FooterSand";
import HeaderSand from "./HeaderSand";
import BodySand from "./BodySand";

function BillPage(props) {
    const { locinf, found, sta,  onUnmountComplete } = props;
    const style = {
        width: "85mm",
        backgroundColor: "#fff",
    };
    const stylle = {
        width: "85mm",
        backgroundColor: "#fff",
    };
    return (
        <Grid item >
            <Fragment>
                <HeaderSand  info={found} onUnmountComplete={onUnmountComplete} />
                <BodySand
                    sta={sta}
                    locinf={locinf}
                    onUnmountComplete={onUnmountComplete}
                />
                 <FooterSand found={found}  onUnmountComplete={onUnmountComplete} />

            </Fragment>
        </Grid>
    );
}
function RevSanadCahCon(props) {
    const { onUnmountComplete } = props;
    const locInv = JSON.parse(localStorage.getItem("datainv")) || {};
    const locinf = JSON.parse(localStorage.getItem("iInfos")) || {};

    const [found, setFound] = useState({});
    const [sta, setSta] = useState({});
    const [loading, setLoading] = useState(true);


    let count_id = 0;
    const getInfo = async () => {
        // alert('getInfo')
        const tb = {
            GetFoundation: true,
            Rpt_Inv: true,
            wait: true,
            SettInvsApp: true,
            parms: {
                lprocid: locInv.proc_id,
                ibranchid: sto.branchi,
                branch: sto.branchi,
                iFoundid: 1,
                sProcTypeInvProc: locInv.ProcTypeInvProc,
            },
            autos: {},
        };
        console.log(tb);
        await axios
            .post(`${uri}Res`, tb)
            .then((res) => {
                setSta({ info: res.data.RptInv, tot: res.data.infoBill, StngIA: res.data.SettInvsApp });
                setFound(res.data.Found);
            })
            .catch((error) => {
                console.log("catch");
            });
    };
    // const getInv = async () => {
    //     axios
    //         .get(uri + `InvForFatora?proc_id=${locInv.proc_id}`)
    //         .then((res) => {
    //             console.log("the inve for fatoora", res.data);
    //             setInv(res.data);
    //         })
    //         .catch((error) => { });
    // };
    useEffect(() => {
        setTimeout(async () => {
            await getInfo();
            // await getInv();
            setLoading(false);
        }, 0);
    }, []);

    if (!found || !sta || loading) return <LoadingPage />;


    return (
        <Typography component="div" >
            <BillPage
                {...{
                    locinf, found, sta,  onUnmountComplete 
                }}
            />
        </Typography>
    );
}
export default RevSanadCahCon;
